import React, { useState } from "react";
import Header from "../../Components/Header/Header";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import "./Listing.css";
import { useQuery, useInfiniteQuery } from "react-query";
import { getUser, getVendors } from "../../utils/profile_helper";
import { Image, Spin } from "antd";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const options = ["All", "Recent", "Oldest"];
const filters = ["Sort by A-Z", "Sort by Z-A", "Sort by location"];
const defaultOption = options[0];

const Listing = () => {
  const navigate = useNavigate();
  const { data: profile, isLoading: isLoading3 } = useQuery("profile", getUser);
  const [isLoading, setIsLoading] = useState(false);
  const [sortBy, setSortBy] = useState({
    id: 0,
    column: "created_at",
    ascending: true,
  });

  const {
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    data: vendors,
  } = useInfiniteQuery(
    ["vendors", profile?.id, sortBy?.id],
    ({ pageParam = 0 }) => getVendors(pageParam, sortBy),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages?.length;
      },
    }
  );

  async function increasePage() {
    try {
      setIsLoading(true);
      if (hasNextPage) {
        await fetchNextPage();
        setIsLoading(false);
      }
    } catch (err) {
      setIsLoading(false);
    }
  }

  // useEffect(() => {
  //   console.log(vendors);
  // }, [vendors]);

  return (
    <>
      <Header />
      <div className="filter">
        <Dropdown
          options={filters}
          value={"Filter"}
          placeholder={"Filter"}
          onChange={(e) => {
            if (e.value === "Sort by A-Z") {
              setSortBy({
                id: 2,
                column: "display_name",
                ascending: true,
              });
            } else if (e.value === "Sort by Z-A") {
              setSortBy({
                id: 3,
                column: "display_name",
                ascending: false,
              });
            } else if (e.value === "Sort by location") {
              setSortBy({
                id: 4,
                column: "location",
                ascending: true,
              });
            }
          }}
        />
        <Dropdown
          options={options}
          value={defaultOption}
          placeholder="Recent"
          onChange={(e) => {
            if (e.value === "Recent") {
              setSortBy({
                id: 1,
                column: "created_at",
                ascending: false,
              });
            } else {
              setSortBy({
                id: 0,
                column: "created_at",
                ascending: true,
              });
            }
          }}
        />
      </div>
      <hr />
      <div className="cardcontainer">
        {isLoading3 ?
          <div>
            <Spin /> &nbsp; Loading....
          </div>
          :
          <>
            {vendors?.pages?.map((page) => {
              return page?.map((vendor) => {
                return (
                  <div
                    className="listingcard"
                    key={vendor?.id}
                    onClick={() => navigate(`/profile/${vendor?.id}`)}
                  >
                    {vendor?.profile_pic ? (
                      <img src={vendor?.profile_pic} alt="bg" />
                    ) : vendor?.cover_pic ? (
                      <img src={vendor?.cover_pic} alt="bg" />
                    ) : (
                      <Image
                        width={"44%"}
                        height={220}
                        src="error"
                        fallback="data:image/png;base64,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"
                        preview={false}
                      />
                    )}

                    <div className="listingname">
                      <p>{vendor?.display_name}</p>
                      <p>{vendor?.location}</p>
                      <p>{vendor?.bio}</p>
                    </div>
                  </div>
                );
              });
            })}
          </>
        }

      </div>
      <div className="load">
        {isLoading ? (
          <Spin />
        ) : (
          <button onClick={increasePage}>Load more</button>
        )}
      </div>
      <br />
    </>
  );
};

export default Listing;
